// extracted by mini-css-extract-plugin
module.exports = {"select":"_1pczc1-pMzmTDV4DgkUYkN","icon":"g5OjKHFkMBZPBuQ50r8z0"};